import React from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Divider,
  Button,
} from "@mui/material";
import { useLanguage } from '../context/LanguageContext';
import { useApp } from '../context/AppContext';

import "../assets/style/Sidebar.css";
// Иконки
import GridViewIcon from "@mui/icons-material/GridView";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaidIcon from "@mui/icons-material/Paid";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

const menuItems = [
  { text: "Overview", icon: <GridViewIcon />, section: "GENERAL", translationKey: "overview" },
  { text: "Account Settings", icon: <SettingsIcon />, section: "GENERAL", translationKey: "accountSettings" },
  { text: "Payments", icon: <PaidIcon />, section: "GENERAL", translationKey: "payments" },
  { text: "Wallets", icon: <AccountBalanceWalletIcon />, section: "GENERAL", translationKey: "wallets" },
  { text: "Transactions", icon: <SwapHorizIcon />, section: "GENERAL", translationKey: "transactions" },
  { text: "Support Tickets", icon: <SupportAgentIcon />, section: "GENERAL", translationKey: "supportTickets" },
  { text: "Safety Guide", icon: <ShieldOutlinedIcon />, section: "GENERAL", translationKey: "safetyGuide" },
  { text: "Exchange", icon: <SwapHorizIcon />, section: "MARKETPLACE", translationKey: "exchange" },
  { text: "Stake", icon: <StackedLineChartIcon />, section: "MARKETPLACE", translationKey: "stake" },
];

export default function Sidebar({
  drawerWidth,
  activeScreen,
  setActiveScreen,
  isMobile,
  mobileOpen,
  handleDrawerToggle,
}) {
  const { t } = useLanguage();
  const { user } = useApp();
  
  // Форматирование даты из created_at
  const formatUserDate = (createdAt) => {
    if (!createdAt) return 'July 4, 2025';
    const date = new Date(createdAt);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };
  const handleMenuItemClick = (screen) => {
    setActiveScreen(screen);
    // Если это мобильное меню, закрываем его после клика
    if (isMobile) {
      handleDrawerToggle();
    }
  };
  const renderListItems = (section) => (
    <>
      <Typography className="nav-section-title">{t(section.toLowerCase())}</Typography>
      {menuItems
        .filter((item) => item.section === section)
        .map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={activeScreen === item.text}
              onClick={() => handleMenuItemClick(item.text)}
              className="sidebar-nav-item"
            >
              <ListItemIcon className="sidebar-nav-icon">
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={t(item.translationKey)} />
            </ListItemButton>
          </ListItem>
        ))}
    </>
  );

  const handleContactSupport = () => {
    setActiveScreen("Support Tickets");
  };

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? mobileOpen : true}
      onClose={handleDrawerToggle} 
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          borderRight: "none", // Убираем рамку
        },
      }}
      // Добавляем класс для стилизации фона
      className="sidebar-drawer"
      elevation={0}
    >
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Верхняя часть: Лого и Пользователь */}
        <div>
          <Typography variant="h6" className="wallet-title">
            PalladiumWallet
          </Typography>
          <div className="user-profile-box">
            <Avatar className="user-avatar" />
            <div className="user-details">
              <Typography variant="body2" className="user-email">
                {user?.email || 'user@example.com'}
              </Typography>
              <Typography variant="caption" className="user-date">
                {formatUserDate(user?.created_at)}
              </Typography>
            </div>
          </div>
        </div>

        {/* Навигация */}
        <List>
          {renderListItems("GENERAL")}
          <Divider className="sidebar-divider" />
          {renderListItems("MARKETPLACE")}
        </List>

        {/* Нижняя часть: Поддержка */}
        <Box sx={{ marginTop: "auto" }}>
          <div className="help-box">
            <Typography variant="subtitle2">{t('needHelp')}</Typography>
            <Typography variant="caption" className="help-box-subtitle">
              {t('contactSupportTeam')}
            </Typography>
            <Button 
              variant="contained" 
              fullWidth 
              className="support-button"
              onClick={handleContactSupport}
            >
              {t('contactSupport')}
            </Button>
          </div>
        </Box>
      </Box>
    </Drawer>
  );
}
